import { Formulario27Component } from './../formulario/formulario27/formulario27.component';
import { Permiso_notariadoComponent } from './../formulario/permiso_notariado/permiso_notariado.component';
import { DeclaracionComponent } from './../formulario/declaracion/declaracion.component';
import { AmpliacionComponent } from './../formulario/ampliacion/ampliacion.component';
import { PermisosComponent } from './../formulario/permisos/permisos.component';
import { Tipo_recepcionComponent } from './../formulario/tipo_recepcion/tipo_recepcion.component';
import { PlazoComponent } from './../formulario/plazo/plazo.component';
import { Tipo_solicitudComponent } from './../formulario/tipo_solicitud/tipo_solicitud.component';
import { FileUploadModule } from 'ng2-file-upload';
import { Caracteristica_proyectoComponent } from './../formulario/caracteristica_proyecto/caracteristica_proyecto.component';
import { ResumenComponent } from './../formulario/resumen/resumen.component';
import { CipComponent } from './../formulario/cip/cip.component';
import { InformeComponent } from './../formulario/informe/informe.component';
import { Tipo_propiedadComponent } from './../formulario/tipo_propiedad/tipo_propiedad.component';
// imports
import { Ng9RutModule  } from 'ng9-rut';
import { NgModule } from '@angular/core';
import { AntecedentesComponent } from '../formulario/antecedentes/antecedentes.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CommonModule } from '@angular/common';
import { ArchivosComponent } from '../formulario/archivos/archivos.component'; 
import { PropiedadComponent } from '../formulario/propiedad/propiedad.component';
import { PropietarioComponent } from '../formulario/propietario/propietario.component';
import { RepresentanteComponent } from '../formulario/representante/representante.component';
import { ArquitectoComponent } from '../formulario/arquitecto/arquitecto.component';
import { IndependienteComponent } from '../formulario/independiente/independiente.component';
import { EmpresaComponent } from '../formulario/empresa/empresa.component';
import { ConstructoresComponent } from '../formulario/constructores/constructores.component';
import { ConstructoraComponent } from '../formulario/constructora/constructora.component';
import { ProyectoComponent } from '../formulario/proyecto/proyecto.component';
import { Datos_proyectoComponent } from '../formulario/datos_proyecto/datos_proyecto.component';
import { RecepcionComponent } from '../formulario/recepcion/recepcion.component';
import { Formulario11Component } from '../formulario/formulario11/formulario11.component';
import { Formulario13Component } from './../formulario/formulario13/formulario13.component';
import { Formulario15Component } from '../formulario/formulario15/formulario15.component';
import { Formulario17Component } from '../formulario/formulario17/formulario17.component';
import { Formulario19Component } from '../formulario/formulario19/formulario19.component';
import { Recepcion_parcialComponent } from '../formulario/recepcion_parcial/recepcion_parcial.component';
import { Antecedentes_edifComponent } from '../formulario/antecedentes_edif/antecedentes_edif.component';
import { superficieComponent } from '../formulario/superficie/superficie.component';
import { UnidadesComponent } from '../formulario/unidades/unidades.component';
import { Permisos_recepComponent } from '../formulario/permisos_recep/permisos_recep.component';
import { clasificacionComponent } from '../formulario/clasificacion/clasificacion.component';
import { DisposicionComponent } from '../formulario/disposicion/disposicion.component';
import { Registro_bienesComponent } from '../formulario/registro_bienes/registro_bienes.component';
import { DestinoComponent } from '../formulario/destino/destino.component';
import { Formulario21Component } from '../formulario/formulario21/formulario21.component';
import { Superficie_anteproyectoComponent } from '../formulario/superficie_anteproyecto/superficie_anteproyecto.component';
import { Permisos_recepcionesComponent } from '../formulario/permisos_recepciones/permisos_recepciones.component';
import { Normas_urbanisticasComponent } from '../formulario/normas_urbanisticas/normas_urbanisticas.component';
import { Disposiciones_espComponent } from '../formulario/disposiciones_especiales/disposiciones_especiales.component';
import { AutorizacionesComponent } from '../formulario/autorizaciones/autorizaciones.component';
import { Uso_publicoComponent } from '../formulario/uso_publico/uso_publico.component';
import { Anteproy_condominioComponent } from '../formulario/anteproy_condominio/anteproy_condominio.component';
import { CondicionesComponent } from '../formulario/condiciones/condiciones.component';
import { tipo_aprobacionComponent } from '../formulario/tipo_aprobacion/tipo_aprobacion.component';
import { Caract_anteproyectoComponent } from '../formulario/caract_anteproyecto/caract_anteproyecto.component';
import { CalculistaComponent } from '../formulario/calculista/calculista.component';
import { Informe_revisorComponent } from '../formulario/informe_revisor/informe_revisor.component';
import { RevisorComponent } from '../formulario/revisor/revisor.component';
import { Otras_solicitudesComponent } from '../formulario/otras_solicitudes/otras_solicitudes.component';
import { Tipo_permisoComponent } from '../formulario/tipo_permiso/tipo_permiso.component';

import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxPaginationModule } from 'ngx-pagination';
import { FilterPipe } from 'src/app/pipes/filter.pipe';

import { Formulario23Component } from '../formulario/formulario23/formulario23.component';
import { HttpClientModule } from '@angular/common/http';
import { Formulario25Component } from '../formulario/formulario25/formulario25.component';
import { S_permiso_primitivoComponent } from '../formulario/s_permiso_primitivo/s_permiso_primitivo.component';
import { Cambio_destinoComponent } from '../formulario/cambio_destino/cambio_destino.component';
import { Superficie_proyecto_modificadoComponent } from '../formulario/superficie_proyecto_modificado/superficie_proyecto_modificado.component';
import { Cambio_profesionalComponent } from '../formulario/cambio_profesional/cambio_profesional.component';
import { Nuevas_normasComponent } from '../formulario/nuevas_normas/nuevas_normas.component';

//Prueba
//prueba
import { Tipo_proyectoComponent } from '../formulario/tipo_proyecto/tipo_proyecto.component';
import { Perm_recep_antComponent } from '../formulario/perm_recep_ant/perm_recep_ant.component';
import { InspectorObraComponent } from '../formulario/inspector_obra/inspector_obra.component';
import { Profesional_compComponent } from '../formulario/profesional_comp/profesional_comp.component';
import { Formulario31Component } from '../formulario/formulario31/formulario31.component';
import { Tipo_loteoComponent } from '../formulario/tipo_loteo/tipo_loteo.component';
import { Caract_anteproy_loteoComponent } from '../formulario/caract_anteproy_loteo/caract_anteproy_loteo.component';
import { Porcentajes_anteproyComponent } from '../formulario/porcentajes_anteproy/porcentajes_anteproy.component';
import { Cond_anteproyComponent } from '../formulario/cond_anteproy/cond_anteproy.component';
import { Formulario33Component } from '../formulario/formulario33/formulario33.component';
import { Tipo_divisionComponent } from '../formulario/tipo_division/tipo_division.component';
import { Caract_divisionComponent } from '../formulario/caract_division/caract_division.component';
import { Caract_fusionComponent } from '../formulario/caract_fusion/caract_fusion.component';
import { Permiso_urbComponent } from '../formulario/permiso_urb/permiso_urb.component';
import { Loteo_constComponent } from '../formulario/loteo_const/loteo_const.component';
import { Formulario36Component } from '../formulario/formulario36/formulario36.component';
import { Tipo_modComponent } from '../formulario/tipo_mod/tipo_mod.component';
import { Reso_modComponent } from '../formulario/reso_mod/reso_mod.component';
import { Mod_parcialComponent } from '../formulario/mod_parcial/mod_parcial.component';
import { Caract_proy_modComponent } from '../formulario/caract_proy_mod/caract_proy_mod.component';
import { Planos_modComponent } from '../formulario/planos_mod/planos_mod.component';
import { Formulario38Component } from '../formulario/formulario38/formulario38.component';
import { Caract_solicitudComponent } from '../formulario/caract_solicitud/caract_solicitud.component';
import { Caract_proy_garantiaComponent } from '../formulario/caract_proy_garantia/caract_proy_garantia.component';
import { Lotes_enajenarComponent } from '../formulario/lotes_enajenar/lotes_enajenar.component';
import { Formulario310Component } from '../formulario/formulario310/formulario310.component';
import { Formulario41Component } from '../formulario/formulario41/formulario41.component';
import { Formulario43Component } from '../formulario/formulario43/formulario43.component';
import { Tipo_garantiaComponent } from '../formulario/tipo_garantia/tipo_garantia.component';
import { Caract_solComponent } from '../formulario/caract_sol/caract_sol.component';
import { Cuenta_con_modComponent } from '../formulario/cuenta_con_mod/cuenta_con_mod.component';
import { Formulario45Component } from '../formulario/formulario45/formulario45.component';
import { Tipo_solicitud_def_urbComponent } from '../formulario/tipo_solicitud_def_urb/tipo_solicitud_def_urb.component';
import { Formulario56Component } from '../formulario/formulario56/formulario56.component';
import { Tipo_condominioComponent } from '../formulario/tipo_condominio/tipo_condominio.component';
import { Reglamento_copropiedadComponent } from '../formulario/reglamento_copropiedad/reglamento_copropiedadcomponent';
import { Formulario58Component } from '../formulario/formulario58/formulario58.component';
import { Tipo_autorizacionComponent } from '../formulario/tipo_autorizacion/tipo_autorizacion.component';
import { Permiso_demolicionComponent } from '../formulario/permiso_demolicion/permiso_demolicion.component';
import { Formulario81Component } from '../formulario/formulario81/formulario81.component';
import { PruebaComponent } from '../formulario/prueba/prueba.component';
import { EmpresaConstructoraComponent } from '../formulario/empresa_constructora/empresa_constructora.component';
import { EmpresaProfesionalComponent } from '../formulario/empresa_profesional/empresa_profesional.component';
import { Formulario01Component } from '../formulario/formulario01/formulario01.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import {MatStepperModule} from '@angular/material/stepper';



// @NgModule decorator with its metadata
@NgModule({
  declarations: [
    AntecedentesComponent,
    PropiedadComponent,
    PropietarioComponent,
    RepresentanteComponent,
    ArquitectoComponent,
    IndependienteComponent,
    EmpresaComponent,
    ConstructoresComponent,
    ConstructoraComponent,
    ProyectoComponent,
    Datos_proyectoComponent,
    ArchivosComponent,
    RecepcionComponent,
    Tipo_propiedadComponent,
    InformeComponent,
    CipComponent,
    ResumenComponent,
    Caracteristica_proyectoComponent,
    Formulario01Component,
    Formulario11Component,
    Formulario13Component,
    Formulario15Component,
    Formulario17Component,
    Formulario19Component,
    Formulario21Component,
    Formulario23Component,
    Formulario25Component,
    Formulario27Component,
    Formulario31Component,
    Formulario38Component,
    Formulario310Component,
    Formulario41Component,
    Formulario43Component,
    Formulario45Component,
    Formulario56Component,
    Formulario58Component,
    Formulario81Component,
    Tipo_solicitudComponent,
    PlazoComponent,
    Tipo_recepcionComponent,
    PermisosComponent,
    AmpliacionComponent,
    DeclaracionComponent,
    Permiso_notariadoComponent,
    Recepcion_parcialComponent,
    Antecedentes_edifComponent,
    superficieComponent,
    UnidadesComponent,
    Permisos_recepComponent,
    clasificacionComponent,
    DisposicionComponent,
    Registro_bienesComponent,
    DestinoComponent,
    tipo_aprobacionComponent,
    Superficie_anteproyectoComponent,
    Permisos_recepcionesComponent,
    Normas_urbanisticasComponent,
    Disposiciones_espComponent,
    AutorizacionesComponent,
    Uso_publicoComponent, 
    Anteproy_condominioComponent,
    CondicionesComponent,
    CalculistaComponent,
    Informe_revisorComponent,
    RevisorComponent,
    Otras_solicitudesComponent,
    Caract_anteproyectoComponent,
    Tipo_permisoComponent,
    FilterPipe,
    S_permiso_primitivoComponent,
    Cambio_destinoComponent,
    Superficie_proyecto_modificadoComponent,
    Cambio_profesionalComponent,
    Nuevas_normasComponent,
    Tipo_proyectoComponent,
    Perm_recep_antComponent,
    InspectorObraComponent,
    Profesional_compComponent,
    Tipo_loteoComponent,
    Caract_anteproy_loteoComponent,
    Porcentajes_anteproyComponent,
    Cond_anteproyComponent,
    Formulario33Component,
    Formulario36Component,
    Tipo_divisionComponent,
    Caract_divisionComponent,
    Caract_fusionComponent,
    Permiso_urbComponent,
    Loteo_constComponent,
    Tipo_modComponent,
    Reso_modComponent,
    Mod_parcialComponent,
    Caract_proy_modComponent,
    Planos_modComponent,
    Caract_solicitudComponent,
    Caract_proy_garantiaComponent,
    Lotes_enajenarComponent,
    Tipo_garantiaComponent,
    Caract_solComponent,
    Cuenta_con_modComponent,
    Tipo_solicitud_def_urbComponent,
    Tipo_condominioComponent,
    Reglamento_copropiedadComponent,
    Tipo_autorizacionComponent,
    Permiso_demolicionComponent,
    PruebaComponent,
    EmpresaProfesionalComponent,
    EmpresaConstructoraComponent
    

  ],
  imports: [
    FormsModule,
    Ng9RutModule,
    NgxPaginationModule,
    CommonModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    FileUploadModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    NgxSpinnerModule,
    HttpClientModule
    
  ],
  exports: [
    AntecedentesComponent,
    PropiedadComponent,
    PropietarioComponent,
    RepresentanteComponent,
    ArquitectoComponent,
    IndependienteComponent,
    EmpresaComponent,
    ConstructoresComponent,
    ConstructoraComponent,
    ProyectoComponent,
    Datos_proyectoComponent,
    ArchivosComponent,
    RecepcionComponent,
    Tipo_propiedadComponent,
    InformeComponent,
    CipComponent,
    ResumenComponent,
    Caracteristica_proyectoComponent,
    Formulario01Component,
    Formulario11Component,
    Formulario13Component,
    Formulario15Component,
    Formulario17Component,
    Formulario19Component,
    Formulario21Component,
    Formulario23Component,
    Formulario25Component,
    Formulario27Component,
    Formulario31Component,
    Formulario38Component,
    Formulario310Component,
    Formulario41Component,
    Formulario43Component,
    Formulario45Component,
    Formulario56Component,
    Formulario58Component,
    Formulario81Component,
    Tipo_solicitudComponent,
    PlazoComponent,
    Tipo_recepcionComponent,
    PermisosComponent,
    AmpliacionComponent,
    DeclaracionComponent,
    Permiso_notariadoComponent,
    Recepcion_parcialComponent,
    Antecedentes_edifComponent,
    UnidadesComponent,
    Permisos_recepComponent,
    clasificacionComponent,
    DisposicionComponent,
    Registro_bienesComponent,
    superficieComponent,
    DestinoComponent, 
    tipo_aprobacionComponent,
    Superficie_anteproyectoComponent, 
    Permisos_recepcionesComponent,
    Normas_urbanisticasComponent,
    Disposiciones_espComponent, 
    AutorizacionesComponent,
    Uso_publicoComponent, 
    Anteproy_condominioComponent,
    CondicionesComponent,
    CalculistaComponent,
    Informe_revisorComponent,
    RevisorComponent,
    Otras_solicitudesComponent,
    Caract_anteproyectoComponent,
    Tipo_permisoComponent,
    S_permiso_primitivoComponent,
    Cambio_destinoComponent,
    Superficie_proyecto_modificadoComponent,
    Cambio_profesionalComponent,
    Nuevas_normasComponent,
    Tipo_proyectoComponent,
    Perm_recep_antComponent,
    InspectorObraComponent,
    Profesional_compComponent,
    Tipo_loteoComponent,
    Caract_anteproy_loteoComponent,
    Porcentajes_anteproyComponent,
    Cond_anteproyComponent,
    Formulario33Component,
    Tipo_divisionComponent,
    Caract_divisionComponent,
    Caract_fusionComponent,
    Permiso_urbComponent,
    Loteo_constComponent,
    Formulario36Component,
    Tipo_modComponent,
    Reso_modComponent,
    Mod_parcialComponent,
    Caract_proy_modComponent,
    Planos_modComponent,
    Caract_solicitudComponent,
    Caract_proy_garantiaComponent,
    Lotes_enajenarComponent,
    Tipo_garantiaComponent,
    Caract_solComponent,
    Cuenta_con_modComponent,
    Tipo_solicitud_def_urbComponent,
    Tipo_condominioComponent,
    Reglamento_copropiedadComponent,
    Tipo_autorizacionComponent,
    Permiso_demolicionComponent,
    PruebaComponent,
    EmpresaProfesionalComponent,
    EmpresaConstructoraComponent
    
    
    
    
  ],
  entryComponents: [
    AntecedentesComponent,
    PropiedadComponent,
    PropietarioComponent,
    RepresentanteComponent,
    ArquitectoComponent,
    IndependienteComponent,
    EmpresaComponent,
    ConstructoresComponent,
    ConstructoraComponent,
    ProyectoComponent,
    Datos_proyectoComponent,
    ArchivosComponent,
    RecepcionComponent,
    Tipo_propiedadComponent,
    InformeComponent,
    CipComponent,
    ResumenComponent,
    Caracteristica_proyectoComponent,
    Formulario01Component,
    Formulario11Component,
    Formulario13Component,
    Formulario15Component,
    Formulario17Component,
    Formulario19Component,
    Formulario21Component,
    Formulario23Component,
    Formulario25Component,
    Formulario27Component,
    Formulario31Component,
    Formulario38Component,
    Formulario310Component,
    Formulario41Component,
    Formulario43Component,
    Formulario45Component,
    Formulario56Component,
    Formulario58Component,
    Formulario81Component,
    Tipo_solicitudComponent,
    PlazoComponent,
    Tipo_recepcionComponent,
    PermisosComponent,
    AmpliacionComponent,
    DeclaracionComponent,
    Permiso_notariadoComponent,
    Recepcion_parcialComponent,
    Antecedentes_edifComponent,
    UnidadesComponent,
    Permisos_recepComponent,
    clasificacionComponent,
    DisposicionComponent,
    Registro_bienesComponent,
    superficieComponent,
    DestinoComponent, 
    tipo_aprobacionComponent,
    Superficie_anteproyectoComponent, 
    Permisos_recepcionesComponent,
    Normas_urbanisticasComponent,
    Disposiciones_espComponent, 
    AutorizacionesComponent,
    Uso_publicoComponent, 
    Anteproy_condominioComponent,
    CondicionesComponent,
    CalculistaComponent,
    Informe_revisorComponent,
    RevisorComponent,
    Otras_solicitudesComponent,
    Caract_anteproyectoComponent,
    Tipo_permisoComponent,
    S_permiso_primitivoComponent,
    Cambio_destinoComponent,
    Superficie_proyecto_modificadoComponent,
    Cambio_profesionalComponent,
    Nuevas_normasComponent,
    Tipo_proyectoComponent,
    Perm_recep_antComponent,
    InspectorObraComponent,
    Profesional_compComponent,
    Tipo_loteoComponent,
    Caract_anteproy_loteoComponent,
    Porcentajes_anteproyComponent,
    Cond_anteproyComponent,
    Formulario33Component,
    Tipo_divisionComponent,
    Caract_divisionComponent,
    Caract_fusionComponent,
    Permiso_urbComponent,
    Loteo_constComponent,
    Formulario36Component,
    Tipo_modComponent,
    Reso_modComponent,
    Mod_parcialComponent,
    Caract_proy_modComponent,
    Planos_modComponent,
    Caract_solicitudComponent,
    Caract_proy_garantiaComponent,
    Lotes_enajenarComponent,
    Tipo_garantiaComponent,
    Caract_solComponent,
    Cuenta_con_modComponent,
    Tipo_solicitud_def_urbComponent,
    Tipo_condominioComponent,
    Reglamento_copropiedadComponent,
    Tipo_autorizacionComponent,
    Permiso_demolicionComponent,
    PruebaComponent,
    EmpresaProfesionalComponent,
    EmpresaConstructoraComponent
  ]
})
export class NavbarModule { }